export class OnPageNav {
    currentLink = null
    constructor () {
        if (!('IntersectionObserver' in window)) {
            return
        }

        const nav = document.querySelector('.onpage-nav .btns')

        if (!nav) {
            return
        }

        const modules = document.querySelectorAll('.section[data-anchor=true]')

        if (!(modules && modules.length)) {
            return
        }
        // get the sticky element
        // const stickyElm = document.querySelector('.onpage-nav')

        // const stickyObserver = new IntersectionObserver(
        //    (entries) => {
        //        const entry = entries[0]
        //        entry.target.dataset.sticky = (!entry.isIntersecting)
        //    },
        //    { threshold: 1, rootMargin: '-80px 0px 0px 0px' }
        // )

        // stickyObserver.observe(stickyElm)

        const observer = new IntersectionObserver((entries) => {
            const entry = entries[0]

            const link = document.querySelector(`.onpage-nav a[href='#${entry.target.id}']`)

            if (link) {
                if (entry.isIntersecting) {
                    if (this.currentLink && this.currentLink !== link) {
                        this.currentLink.dataset.active = false
                    }
                    link.dataset.active = true
                    this.currentLink = link
                } else {
                    link.dataset.active = false
                }
            } else if (this.currentLink) {
                this.currentLink.dataset.active = false
            }
        }, { root: null, threshold: 0, rootMargin: '-170px 0px -50% 0px' })

        modules.forEach(el => {
            observer.observe(el)
        })
    }
}
